<h3>Uw {{ productName }}</h3>
<table class="table-data table-data--polis" *ngIf="purchasedProduct">
    <colgroup>
        <col width="33%" />
        <col width="33%" />
        <col width="33%" />
    </colgroup>
    <tbody>
        <tr>
            <td>Kenteken</td>
            <td>{{ purchasedProduct?.product?.caravan?.licensePlate | kenteken }}</td>
            <td></td>
        </tr>
        <tr>
            <td>Merk</td>
            <td>
                {{ purchasedProduct?.product?.caravan?.caravanBrand | capitalize }}
                {{ purchasedProduct?.product?.caravan?.caravanModel }}
                <span
                    *ngIf="purchasedProduct?.product?.caravan?.caravanModel"
                    placement="top"
                    insTooltip="Is dit niet helemaal uw type? Geen zorgen, we verzekeren de uitvoering die bij uw kenteken hoort."
                >
                    <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#informatie"></use></svg>
                </span>
            </td>
            <td></td>
        </tr>
        <tr>
            <td>Afgifte kenteken</td>
            <td>{{ purchasedProduct?.product?.caravan?.licencePlateIssuedDate | dateFormat }}</td>
            <td></td>
        </tr>
    </tbody>
</table>
